import Phaser from 'phaser';
import { SCENES, SPRITE_SOURCES, POKEMON_DEMO_DATA } from '../utils/constants';

export class PreloadScene extends Phaser.Scene {
  private loadingBar!: Phaser.GameObjects.Graphics;
  private progressBar!: Phaser.GameObjects.Graphics;
  private loadingText!: Phaser.GameObjects.Text;

  constructor() {
    super({ key: SCENES.PRELOAD });
  }

  preload() {
    this.createLoadingBar();
    this.loadAssets();
    this.setLoadEvents();
  }

  private createLoadingBar() {
    const width = 400;
    const height = 30;
    const x = (this.cameras.main.width - width) / 2;
    const y = this.cameras.main.height / 2;

    this.progressBar = this.add.graphics();
    this.loadingBar = this.add.graphics();

    this.loadingBar.fillStyle(0x222222, 0.8);
    this.loadingBar.fillRect(x, y, width, height);

    this.loadingText = this.add
      .text(this.cameras.main.width / 2, y - 50, 'Loading Pokemon...', {
        fontSize: '24px',
        color: '#ffffff',
      })
      .setOrigin(0.5);
  }

  private loadAssets() {
    // Load video background
    this.load.video('pond-bg', 'assets/videos/pond.mp4');

    // Load logo
    this.load.svg('logo', 'assets/logo.svg');

    // Load Pokemon sprites from PokeAPI
    // Reference: See docs/resources.md for sprite sources
    POKEMON_DEMO_DATA.forEach((pokemon) => {
      const spriteKey = pokemon.name.toLowerCase();
      const url = `${SPRITE_SOURCES.POKEAPI}${pokemon.id}.png`;
      this.load.image(spriteKey, url);
    });
  }

  private setLoadEvents() {
    this.load.on('progress', (value: number) => {
      const width = 400;
      const height = 30;
      const x = (this.cameras.main.width - width) / 2;
      const y = this.cameras.main.height / 2;

      this.progressBar.clear();
      this.progressBar.fillStyle(0x88ff88, 1);
      this.progressBar.fillRect(x, y, width * value, height);

      this.loadingText.setText(`Loading: ${Math.floor(value * 100)}%`);
    });

    this.load.on('complete', () => {
      this.progressBar.destroy();
      this.loadingBar.destroy();
      this.loadingText.destroy();
    });
  }

  create() {
    this.scene.start(SCENES.MAIN_MENU);
  }
}
